import React from "react";
import { Helmet } from "react-helmet-async";
import LegalPageLayout from "./shared/LegalPageLayout";

const PrivacyPolicy = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy - The Wart Guy</title>
        <meta
          name="description"
          content="Privacy Policy for The Wart Guy website - Learn how we collect, use and protect your personal information."
        />
      </Helmet>

      <LegalPageLayout
        title="Privacy Policy"
        subtitle={`Effective ${new Date().toLocaleDateString()}`}
      >
        <p>
          At The Wart Guy, we value your privacy and are committed to protecting
          your personal information. This Privacy Policy explains how we
          collect, use, and protect your data when you visit our platform, which
          provides resources and information for individuals suffering from
          plantar warts. By using our website, you agree to the collection and
          use of information in accordance with this policy.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Anonymous Data:</strong> Since users do not create accounts
            on our platform, the information we collect is generally anonymous.
            This may include information such as your IP address, browser type,
            pages visited, and time spent on the site. This helps us improve our
            services and understand how visitors interact with our platform.
          </li>
          <li>
            <strong>User-Submitted Content:</strong> We collect any content you
            voluntarily submit to the website, such as testimonials, comments,
            or forum posts. This content may be shared publicly but will be kept
            anonymous.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the collected information to:</p>
        <ul>
          <li>Provide and maintain our service</li>
          <li>Improve user experience</li>
          <li>Communicate with you about updates or inquiries</li>
          <li>Monitor usage of our website</li>
        </ul>

        <h2>3. Information Sharing</h2>
        <p>
          We do not sell or rent your personal information to third parties. We
          may share anonymous, aggregated data for analytical purposes.
        </p>

        <h2>4. Cookies</h2>
        <p>
          We use cookies to enhance your browsing experience and analyze website
          traffic. You can control cookie settings through your browser
          preferences.
        </p>

        <h2>5. Security</h2>
        <p>
          We implement reasonable security measures to protect your personal
          information. However, no method of transmission over the internet is
          100% secure.
        </p>

        <h2>6. Changes to Privacy Policy</h2>
        <p>
          We may update this privacy policy from time to time. We will notify
          you of any changes by posting the new policy on this page.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy or our
          data practices, please contact us at:
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:info@thewartguy.com">info@thewartguy.com</a>
        </p>
      </LegalPageLayout>
    </>
  );
};

export default PrivacyPolicy;
